<!-- 分页组件 -->
<template>
  <div class="flexRow paginationContainer" v-if="pageList.length > 0">
    <div class="main">
      <div class="mr20">
        共 {{ totalPages }} 页/
        <span class="totalNum">{{ total }}</span>
        条数据
      </div>
      <div
        class="mr20 cursor prev"
        :class="{ disabled: currentPage === 1 }"
        @click="handlePrevPage"
      >
        上一页
      </div>
      <ul>
        <li
          v-for="(page, index) in pageList"
          :key="index"
          @click="handlePageClick(page)"
          :class="{ active: currentPage == page, disabled: page === '...' }"
        >
          {{ page }}
        </li>
      </ul>
      <div
        class="mr20 cursor next"
        :class="{ disabled: currentPage === totalPages }"
        @click="handleNextPage"
      >
        下一页
      </div>
      <span class="ml20">跳至</span>
      <input v-model="jumpPage" @blur="handleJumpPage" @keydown.enter="handleJumpPage" />
      <span class="ml10">页</span>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from "vue"
import { Toast } from "vant"

Vue.use(Toast)

export default {
  name: "BaseListPager",
  data() {
    return {
      total: 0, // 总数
      pageList: [], // 显示的页数列表
      currentPage: 1, // 当前页
      totalPages: 1, // 总页数
      jumpPage: 1, // 跳转页数
    }
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.$watch(
      "config",
      newValue => {
        this.updatePagination(newValue)
      },
      { deep: true, immediate: true }
    )
  },
  methods: {
    // 上一页
    handlePrevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.calculatePageList()
        this.$nextTick(() => {
          this.$emit("currentPage", this.currentPage)
        })
      }
    },
    // 下一页
    handleNextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
        this.calculatePageList()
        this.$nextTick(() => {
          this.$emit("currentPage", this.currentPage)
        })
      }
    },
    // 更新分页信息
    updatePagination(config) {
      this.total = config.total
      this.currentPage = config.pageNum + 1
      this.totalPages = config.pages
      this.jumpPage = this.currentPage

      this.calculatePageList()
    },

    // 计算分页列表
    calculatePageList() {
      this.pageList = []
      const total = this.totalPages
      const current = this.currentPage

      if (total <= 7) {
        for (let i = 1; i <= total; i++) {
          this.pageList.push(i)
        }
        return
      }

      let list = []
      // Case 1: Near the start
      if (current < 5) {
        list = [1, 2, 3, 4, 5, "...", total]
      }
      // Case 2: Near the end
      else if (current > total - 4) {
        list = [1, "...", total - 4, total - 3, total - 2, total - 1, total]
      }
      // Case 3: In the middle, show 5 pages
      else {
        list = [1, "..."]
        for (let i = current - 2; i <= current + 2; i++) {
          list.push(i)
        }
        list.push("...", total)
      }
      this.pageList = list
    },

    // 处理页面点击
    handlePageClick(page) {
      if (page === "..." || page === this.currentPage) return

      this.currentPage = page
      this.jumpPage = page
      this.calculatePageList()
      this.$emit("currentPage", page)
    },

    // 处理跳转页面
    handleJumpPage(event) {
      const target = event.target || event
      const inputPageNum = parseInt(target.value)

      if (isNaN(inputPageNum)) {
        this.jumpPage = this.currentPage
        return
      }

      let validPage = Math.max(1, Math.min(this.totalPages, inputPageNum))
      this.jumpPage = validPage

      if (validPage !== this.currentPage) {
        this.handlePageClick(validPage)
      }
    },
  },
}
</script>
<style lang="less" scoped>
.paginationContainer {
  padding: 0px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #b4b4b4;

  .main {
    height: 50px;
    display: flex;
    align-items: center;
  }

  .main input {
    outline: none;
    padding: 0px 10px;
    margin-left: 10px;
    border: 1px solid #eeeeee;
    width: 40px;
    text-align: center;
  }

  ul {
    margin: 0;
    padding: 0;
    display: flex;
  }

  li {
    list-style: none;
    margin: 0;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #b4b4b4;
    margin-right: 15px;
    cursor: pointer;
    transition: all 0.2s ease;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    &.disabled {
      cursor: default;
    }

    &:hover:not(.active):not(.disabled) {
      color: #0e79e3;
    }
  }

  .active {
    color: #fff;
    background-color: #0e79e3;
    border-radius: 2px;
    cursor: not-allowed;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
  }
  .prev,
  .next {
    height: 30px;
    text-align: center;
    line-height: 30px;
    background: #efefef;
    color: #222;
    padding: 0 10px;
    border-radius: 4px;
  }
  .disabled {
    color: #9e9e9e;
    cursor: not-allowed;
  }
}
</style>
